// Moneda de presentación de Métricas.
//
// El backend convierte TODOS los montos (revenue, pauta, costos) a la moneda del owner
// y la expone en `summary.currency`; el front la registra aquí al cargar el summary y
// todos los formatters la usan. Default COP mientras no haya respuesta (paridad con el
// comportamiento histórico).

let ownerCurrency = "COP";

const LOCALE_BY_CURRENCY: Record<string, string> = {
  COP: "es-CO",
  USD: "en-US",
  MXN: "es-MX",
  PYG: "es-PY",
  ARS: "es-AR",
  CLP: "es-CL",
  PEN: "es-PE",
  GTQ: "es-GT",
  BRL: "pt-BR",
  UYU: "es-UY",
  BOB: "es-BO",
  VES: "es-VE",
  CAD: "en-CA",
};

export function setOwnerCurrency(currency?: string | null): void {
  const normalized = currency?.trim().toUpperCase();
  if (normalized && normalized.length === 3) ownerCurrency = normalized;
}

export function getOwnerCurrency(): string {
  return ownerCurrency;
}

export function getOwnerCurrencyLocale(): string {
  return LOCALE_BY_CURRENCY[ownerCurrency] ?? "es-CO";
}

// Formatea un monto en la moneda del owner (o una explícita, p. ej. un costo fijo
// que quedó en su moneda nativa por falta de tasa).
export function formatOwnerCurrency(
  value: number,
  options: Intl.NumberFormatOptions = {},
  currency?: string | null,
): string {
  const code = currency?.trim().toUpperCase() || ownerCurrency;
  const locale = LOCALE_BY_CURRENCY[code] ?? getOwnerCurrencyLocale();
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: code,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
    ...options,
  }).format(value);
}
